(() => {
  const init = () => {
    if (window.innerWidth > 992) return;
    const gallery = document.querySelector('.st_sortiment .wrap-gallery-collection');
    if (!gallery || gallery.dataset.tznLightboxReady === 'true') return;

    const rawImages = Array.from(gallery.querySelectorAll('img'));
    const seen = new Set();
    const images = rawImages.filter((img) => {
      const src = img.currentSrc || img.src;
      if (!src || seen.has(src)) return false;
      seen.add(src);
      return true;
    });
    if (!images.length) return;

    gallery.dataset.tznLightboxReady = 'true';
    images.forEach((img) => {
      img.classList.remove('gallery-popup-img');
      img.classList.add('tzn-gallery-popup-trigger');
    });

    const oldPopup = document.querySelector('.st_sortiment .gallery-mobile-popup');
    if (oldPopup) oldPopup.setAttribute('aria-hidden', 'true');

    const overlay = document.createElement('div');
    overlay.className = 'tzn-home-gallery-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-label', 'Vergrößerte Galerie');

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'tzn-home-gallery-lightbox__close';
    close.setAttribute('aria-label', 'Galerie schließen');
    close.textContent = '×';

    const prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'tzn-home-gallery-lightbox__nav tzn-home-gallery-lightbox__prev';
    prev.setAttribute('aria-label', 'Vorheriges Bild');
    prev.textContent = '‹';

    const next = document.createElement('button');
    next.type = 'button';
    next.className = 'tzn-home-gallery-lightbox__nav tzn-home-gallery-lightbox__next';
    next.setAttribute('aria-label', 'Nächstes Bild');
    next.textContent = '›';

    const track = document.createElement('div');
    track.className = 'tzn-home-gallery-lightbox__track';

    images.forEach((source, index) => {
      const slide = document.createElement('div');
      slide.className = 'tzn-home-gallery-lightbox__slide';
      slide.setAttribute('aria-label', `Bild ${index + 1} von ${images.length}`);
      const image = document.createElement('img');
      image.dataset.src = source.dataset.zoomSrc || source.currentSrc || source.src;
      image.decoding = 'async';
      image.alt = source.alt || '';
      image.draggable = false;
      slide.appendChild(image);
      track.appendChild(slide);
    });

    const counter = document.createElement('div');
    counter.className = 'tzn-home-gallery-lightbox__counter';
    counter.setAttribute('aria-live', 'polite');

    overlay.append(close, prev, track, next, counter);
    document.body.appendChild(overlay);

    let activeIndex = 0;
    let lastTrigger = null;
    let scrollTimer = null;

    const normalize = (index) => (index + images.length) % images.length;
    const updateCounter = () => { counter.textContent = `${activeIndex + 1} / ${images.length}`; };
    const goTo = (index, behavior = 'smooth') => {
      activeIndex = normalize(index);
      [activeIndex, normalize(activeIndex - 1), normalize(activeIndex + 1)].forEach(position => {
        const image = track.children[position]?.querySelector('img');
        if (image?.dataset.src) { image.src = image.dataset.src; delete image.dataset.src; }
      });
      updateCounter();
      track.scrollTo({ left: activeIndex * track.clientWidth, behavior });
    };

    const open = (index, trigger) => {
      lastTrigger = trigger;
      activeIndex = index;
      updateCounter();
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('tzn-gallery-lightbox-open');
      requestAnimationFrame(() => requestAnimationFrame(() => goTo(index, 'auto')));
      close.focus({ preventScroll: true });
    };

    const closeLightbox = () => {
      if (!overlay.classList.contains('is-open')) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('tzn-gallery-lightbox-open');
      if (lastTrigger) {
        try { lastTrigger.focus({ preventScroll: true }); } catch (e) { lastTrigger.focus(); }
      }
    };

    images.forEach((img, index) => {
      img.setAttribute('role', 'button');
      img.setAttribute('tabindex', '0');
      img.setAttribute('aria-label', `Bild ${index + 1} von ${images.length} vergrößern`);
      img.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        open(index, img);
      }, true);
      img.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          open(index, img);
        }
      });
    });

    close.addEventListener('click', closeLightbox);
    prev.addEventListener('click', () => goTo(activeIndex - 1));
    next.addEventListener('click', () => goTo(activeIndex + 1));
    overlay.addEventListener('click', (event) => { if (event.target === overlay) closeLightbox(); });

    track.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        if (!track.clientWidth) return;
        activeIndex = Math.max(0, Math.min(images.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        updateCounter();
      }, 70);
    }, { passive: true });

    document.addEventListener('keydown', (event) => {
      if (!overlay.classList.contains('is-open')) return;
      if (event.key === 'Escape') closeLightbox();
      if (event.key === 'ArrowLeft') goTo(activeIndex - 1);
      if (event.key === 'ArrowRight') goTo(activeIndex + 1);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 992) closeLightbox();
      else if (overlay.classList.contains('is-open')) goTo(activeIndex, 'auto');
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();